module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1.93089","quantity":0.01931},{"color":"#9dc4b5","label":" 1.93089- 2.10357","quantity":0.02104},{"color":"#e6efc3","label":" 2.10357- 2.5787","quantity":0.02579},{"color":"#ffe89e","label":" 2.5787- 3.38995","quantity":0.0339},{"color":"#f5af7f","label":" 3.38995- 4.71756","quantity":0.04718},{"color":"#ed6d32","label":" 4.71756- 18.61625","quantity":0.18616}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_80_return_10.json
// module id = Q7sB
// module chunks = 171